<template>
  <base-modal form title="Capture Offline Payment" body-class="is-paddingless">
    <notification class="is-info is-radiusless is-marginless">
      Please supply the <a>date</a> and <a>amount</a> of the offline payment.
    </notification>
    <div class="columns is-multiline p-2">
      <div class="column is-12">
        <date-picker
          no-time
          v-model="booking.additional_billing_invoice.payment_received"
          :error="errors.payment_received"
          error-class="has-text-danger">
          <static-button slot="left">Payment Date</static-button>
        </date-picker>
      </div>
      <div class="column is-12">
        <formatted-text-input
          :options="{
            numeral: true,
            numeralPositiveOnly: true,
            numeralDecimalScale: 2,
            numeralIntegerScale: 5,
          }"
          v-model="booking.additional_billing_invoice.payment_amount"
          :error="errors.payment_amount"
          error-class="has-text-danger">
          <static-button slot="left">R</static-button>
        </formatted-text-input>
      </div>
    </div>
    <div slot="footer" class="buttons">
      <submit-button
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { captureAdditionalBillingPayment } from '@/api/booking'

export default {

  props: {
    payload: Object
  },

  data:() => ({
    working: false,
    booking: {
      additional_billing_invoice: {
        payment_received: '',
        payment_amount: 0
      }
    }
  }),

  created() {
    this.booking = { ...this.payload }
  },

  methods: {
    save() {
      this.working = true
      captureAdditionalBillingPayment(this.booking, () => {
        this.$toast.success('Payment captured.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }
}
</script>
